






































































































import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import Vue, { PropType } from 'vue';
import Button from '~/components/builders/Base/Button.vue';
import Icon from '~/components/builders/Base/Icon.vue';
import Modal from '~/components/builders/Base/Modal.vue';
import { VFair, VFairProfileRequirementLevel } from '~/services/types/vfair';
import CandidateService, {
    Candidate,
    WorkAuthorization as WAType,
} from '~/services/CandidateService';
import CommunicationService, { EmailSettings } from '~/services/CommunicationService';
import IdentityService, { User } from '~/services/IdentityService';
import {
    getRequiredFields,
    IMissingFieldValidation,
    IProfileData,
    loadUserProfileData,
    validateProfileData,
} from '~/utils/user/validateCandidateData';
import SpotLightForm from '~/views/spotlight/SpotLightForm.vue';
import AddToCalendarButton from './AddToCalendarButton.vue';
import DateRange from './DateRange.vue';

interface DataType {
    identityService: IdentityService;
    candidateService: CandidateService;

    isLoading: boolean;
    isLoadingSubmit: boolean;
    isFormValid: boolean;
    modalOpen: boolean;

    profileData: IProfileData | null;
    requiredFields: IMissingFieldValidation;
}

export default Vue.extend({
    name: 'RegisterProfileModal',
    components: {
        Modal,
        Button,
        Icon,
        DateRange,
        AddToCalendarButton,
        SpotLightForm,
    },
    props: {
        show: {
            type: Boolean,
            required: true,
        },
        type: {
            type: String as PropType<'register' | 'enter'>,
            required: true,
        },
        vfair: {
            type: Object as PropType<VFair | null>,
            default: null,
        },

        loading: {
            type: Boolean,
            required: true,
        },
        completed: {
            type: Boolean,
            required: true,
        },
        ongoing: {
            type: Boolean,
            required: true,
        },
    },
    async mounted() {
        if (this.vfair) this.requiredFields = getRequiredFields(this.vfair.profileRequirementLevel);

        await this.load();
    },
    data(): DataType {
        return {
            identityService: new IdentityService(),
            candidateService: new CandidateService(),

            isLoading: false,
            isLoadingSubmit: false,
            isFormValid: false,
            modalOpen: false,

            profileData: null,
            requiredFields: getRequiredFields(),
        };
    },
    computed: {
        requirementLevel(): VFairProfileRequirementLevel {
            return this.vfair
                ? this.vfair.profileRequirementLevel || VFairProfileRequirementLevel.Regular
                : VFairProfileRequirementLevel.Regular;
        },
    },
    methods: {
        async load(): Promise<void> {
            this.isLoading = true;
            this.profileData = await loadUserProfileData();

            this.$store.commit('profileModule/setUser', this.profileData.identityData);
            this.$store.commit('profileModule/setCandidate', this.profileData.candidateData);

            this.isLoading = false;
            const valid = this.checkIsValid();
            this.$emit('valid', valid);
        },
        async loadEmailSettings() {
            return CommunicationService.getEmailSettings().then(settings => {
                !!this.profileData && (this.profileData.emailSettings = settings);
            });
        },
        checkIsValid(): boolean {
            const valid =
                !!this.profileData && validateProfileData(this.profileData, this.requiredFields);
            return Object.values(valid).every(x => x);
        },
        onValidateChange(isValid: boolean): void {
            this.isFormValid = isValid;
        },
        onLoadingChange(isLoading: boolean): void {
            this.isLoading = isLoading;
        },
        isValid(isValid: boolean): void {
            if (isValid) {
                this.$emit('valid', isValid);
                this.$emit('success');
            }
        },
        async handleSubmit(): Promise<void> {
            this.isLoadingSubmit = true;
            // @ts-ignore
            let isOK = await this.$refs.spotLightForm.handleSave();
            this.isLoadingSubmit = false;

            if (isOK) {
                this.isValid(isOK);
            }
        },
        handleClose() {
            // @ts-ignore
            this.$emit('close');
        },
    },
    watch: {
        show(value: boolean) {
            if (value) {
                this.modalOpen = true;
            } else {
                const modal = this.$refs.scrollable as Element;
                if (!!modal) enableBodyScroll(modal);
                this.modalOpen = false;
            }
        },
        modalOpen(value: boolean) {
            if (!value) return;

            setTimeout(() => {
                const modal = this.$refs.scrollable as Element;
                if (!modal) return;
                disableBodyScroll(modal);
            }, 10);
        },
        vfair(value: VFair | null) {
            if (value) this.requiredFields = getRequiredFields(value.profileRequirementLevel);
        },
    },
});
